import FloatingWhatsapp from './FloatingWhatsapp';
export default FloatingWhatsapp;
